import React from 'react';

// Component Icon với màu sắc mới, nổi bật hơn
const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-4 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

/**
 * Component này hiển thị thông báo trong một modal với giao diện chuyên nghiệp.
 * Nó hiển thị thông báo đầu tiên trong danh sách và bao gồm tên bộ phận gửi.
 * @param {object[]} notifications - Mảng các đối tượng thông báo chưa đọc.
 * @param {function} onClose - Hàm sẽ được gọi với ID của thông báo khi người dùng đóng modal.
 */
export default function NotificationViewer({ notifications, onClose }) {
    const notificationToShow = notifications && notifications.length > 0 ? notifications[0] : null;

    if (!notificationToShow) {
        return null;
    }

    // Xác định bộ phận gửi. Mặc định là 'THÔNG BÁO' nếu không có dữ liệu.
    const sender = notificationToShow.Sender || 'THÔNG BÁO';

    const handleClose = () => {
        onClose(notificationToShow.NotificationID);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 transition-opacity duration-300 animate-fade-in">
            {/* --- Container chính của Modal với nền trắng và đổ bóng lớn --- */}
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg overflow-hidden transform transition-all animate-fade-in-down" role="dialog" aria-modal="true" aria-labelledby="notification-sender">
                
                {/* --- Header: Sáng sủa hơn với đường viền dưới --- */}
                <div className="bg-gray-50 p-5 flex items-center justify-between border-b border-gray-200">
                    <div className="flex items-center">
                        <InfoIcon />
                        <div>
                            <h2 id="notification-sender" className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
                                Thông báo từ
                            </h2>
                            <p className="text-xl font-bold text-indigo-700">{sender}</p>
                        </div>
                    </div>
                    <button 
                        onClick={handleClose}
                        className="text-gray-400 hover:text-gray-700 rounded-full p-1 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors"
                        aria-label="Đóng"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* --- Body: Tăng kích thước chữ và độ tương phản --- */}
                <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">{notificationToShow.Title}</h3>
                    <div 
                        className="prose max-w-none text-gray-600 text-base"
                        dangerouslySetInnerHTML={{ __html: notificationToShow.Content }} 
                    />
                </div>

                {/* --- Footer: Nút bấm nổi bật hơn --- */}
                <div className="bg-gray-50 p-4 text-right border-t border-gray-200">
                    <button 
                        onClick={handleClose}
                        className="px-8 py-3 bg-indigo-600 text-white font-bold rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all transform hover:scale-105"
                    >
                        Đã hiểu
                    </button>
                </div>
            </div>

            {/* --- CSS cho animation (giữ nguyên) --- */}
            <style>{`
                @keyframes fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                .animate-fade-in {
                    animation: fade-in 0.3s ease-out forwards;
                }
                @keyframes fade-in-down {
                    0% {
                        opacity: 0;
                        transform: translateY(-20px) scale(0.95);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }
                .animate-fade-in-down {
                    animation: fade-in-down 0.4s ease-out forwards;
                }
            `}</style>
        </div>
    );
}

